import React from "react";
import { useTranslation } from "react-i18next";
import { ApiInternal } from "src/api/api_internal";
import { SimpleUser } from "src/api/generated/frontend_internal_v1";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link DeleteLocalUserDialog}
 */
export type DeleteLocalUserDialogProps = {
    /** User uuid of the local or invited user */
    simpleUser: SimpleUser | undefined;
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDelete: () => void;
};

/**
 * Delete local or invited user
 */
export default function DeleteLocalUserDialog(props: DeleteLocalUserDialogProps) {
    const [t] = useTranslation("dialog-delete-local-user");

    if (!props.simpleUser) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.simpleUser) return;
                await ApiInternal.users.deleteLocal(props.simpleUser.uuid);
                notify.success(t("toast.successfully-deleted-user"));
                props.onDelete();
            }}
            title={t("heading.delete-local-user", { user_name: props.simpleUser.display_name })}
            description={t("description.delete-local-user")}
            confirmLabel={t("button.delete")}
            cancelLabel={t("button.cancel")}
        />
    );
}
